import { atQuery } from "../components/mediaQueries";


if (!window.pingInit) window.pingInit = {};
window.pingInit.initAnnouncementBar = (announcementBar) => {
  if (
    !announcementBar ||
    announcementBar.classList.contains("announcement-bar--marquee-loaded")
  )
    return;

  const $announcementBar = $(announcementBar);
  const marqueeOptions = {
    duration: 20000,
    gap: 0,
    delayBeforeStart: 0,
    direction: "left",
    startVisible: true,
    pauseOnHover: true,
  };

  atQuery("min", "lg", () => {
    $announcementBar.marquee("destroy");
  });

  atQuery("max", "lg", () => {
    $announcementBar.marquee(marqueeOptions);
  });

  announcementBar.classList.add("announcement-bar--marquee-loaded");
};

if (document.readyState != "loading") {
  window.pingInit.initAnnouncementBar(
    document.querySelector(".announcement-bar")
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    window.pingInit.initAnnouncementBar(
      document.querySelector(".announcement-bar")
    );
  });
}
